import React, { Component } from 'react';
import * as CompanyLinkApi from '../api/CompanyLinkApi'
import * as LoginApi from '../api/LoginApi'
import { Spinner } from '../utils/spinner';
import toast from 'react-hot-toast';

export class UnlinkCompany extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            userHasAccess: false,
            companyLinks: [],
            searchType: 'companyName',
            searchQuery: ''
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getCompanyLinks = this.getCompanyLinks.bind(this);
        this.unlinkCompany = this.unlinkCompany.bind(this);
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    componentDidMount() {
        LoginApi.getAuthenticationInfo()
            .then(data => {
                if (data.userId !== null && data.userName !== null)
                    this.setState({
                        userHasAccess: data
                    });
            })
            .catch(() => {
                this.setState({ isLoading: false });
                toast.error("Something went wrong.");
            })
    }

    getCompanyLinks() {
        if (this.state.searchQuery === '') {
            toast.error("Search query can't be empty.")
            return;
        }

        let body = {
            companyLinkQueryInfo: {
                searchType: this.state.searchType,
                searchQuery: this.state.searchQuery
            }
        };
        this.setState({ isLoading: true });

        CompanyLinkApi.getCompanyLinks(body)
            .then(resultInJson => {
                this.setState({ isLoading: false });
                var data = JSON.parse(resultInJson);
                if (data.ErrorCode === 0 && data.ReturnObject.CompanyLinks.length > 0) {
                    this.setState({
                        companyLinks: data.ReturnObject.CompanyLinks
                    });
                }
                else {
                    toast.error("No company links found for the query.");
                }
            })
            .catch(() => {
                this.setState({ isLoading: false });
                toast.error("Something went wrong.");
            });
    }

    unlinkCompany(userId, companyId) {
        const confirmed = window.confirm("Are you sure you want to unlink this company?");

        if (confirmed) {
            let body = {
                userId,
                companyId
            };
            this.setState({ isLoading: true });

            CompanyLinkApi.unlinkCompany(body)
                .then(resultInJson => {
                    this.setState({ isLoading: false });
                    toast.success("Company unlinked successfully");
                    this.setState({
                        companyLinks: this.state.companyLinks.filter(item => {
                            return !(item.UserId === userId && item.CompanyId === companyId);
                        })
                    });
                })
                .catch(() => {
                    this.setState({ isLoading: false });
                    toast.error("Something went wrong.");
                });
        }
    }

    renderCompanyLinksTable(companyLinks) {
        return (
            <table className="table">
                <thead>
                    <tr height="80px">
                        <th scope="col">User Email</th>
                        <th scope="col">User Type</th>
                        <th scope="col">Company Name</th>
                        <th scope="col">DB Guid</th>
                    </tr>
                </thead>
                <tbody>
                    {companyLinks.map(companyLink => {
                        return (
                            <React.Fragment key={`${companyLink.UserId}-${companyLink.CompanyId}-fragment`}>
                                <tr key={`${companyLink.UserId}-${companyLink.CompanyId}`}>
                                    <td>{companyLink.UserEmail}</td>
                                    <td>{companyLink.UserType}</td>
                                    <td>{companyLink.CompanyName}</td>
                                    <td>{companyLink.CompanyId}</td>
                                    <td>
                                        <div className="d-flex justify-content-center">
                                            <button className="btn btn-danger" onClick={() => this.unlinkCompany(companyLink.UserId, companyLink.CompanyId)}>Unlink Company</button>
                                        </div>
                                    </td>
                                </tr>
                            </React.Fragment>
                        )
                    }
                    )}
                </tbody>
            </table>
        )
    }

    render() {
        return (
            <>
                <Spinner isLoading={this.state.isLoading} />
                {this.state.userHasAccess
                    ?
                    <>
                        <div className="row mb-3">
                            <div className="fs-5 fw-bold">Unlink Company</div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-6">
                                <label>Search Type</label>
                                <select className="form-select" aria-label="Default select example" name="searchType" value={this.state.searchType} onChange={this.handleInputChange}>
                                    <option value="companyName">Company Name</option>
                                    <option value="userEmail">User Email</option>
                                </select>
                            </div>
                            <div className="col-6">
                                <label>Search Query</label>
                                <input className="form-control" type="text" placeholder="Search Query" name="searchQuery" value={this.state.searchQuery} onChange={this.handleInputChange} />
                            </div>
                        </div>

                        <div className="d-flex justify-content-start">
                            <button className="btn btn-primary col-4" onClick={this.getCompanyLinks}>Query Company Links</button>
                        </div>

                        {this.renderCompanyLinksTable(this.state.companyLinks)}
                        {this.state.companyLinks.length === 0 && 'Please filter/search company links.'}
                    </>
                    : <div>User is not logged in or doesn't have access to this platform, please go back to <a href="/">Home Page</a> and login to another account.</div>
                }
            </>
        );
    }
}
